"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const quotes = [];
export default function ArtistsEcho() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21700" id="voices-of-safety" className="bg-background text-foreground py-24 md:py-32 overflow-hidden relative before:absolute before:inset-0 before:bg-[url('https://www.transparenttextures.com/patterns/felt.png')] before:opacity-10 before:pointer-events-none">
      <div ref={ref} className={cn("container mx-auto px-6 md:px-12 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <Carousel opts={{
        loop: true,
        align: "start"
      }} className="w-full relative">
          <CarouselContent>
            {quotes.length > 0 ? quotes.map((quote, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col justify-between min-h-[400px] md:min-h-[500px]">
                    <div className="max-w-5xl">
                      <blockquote className="font-sans italic text-[28px] md:text-[32px] lg:text-[40px] leading-relaxed tracking-tight text-foreground relative">
                        <span className="absolute -top-12 -left-8 text-8xl text-primary/10 font-serif not-italic select-none">&ldquo;</span>
                        {quote.text}
                      </blockquote>
                    </div>
                    
                    <div className="mt-12 md:mt-0">
                      <cite className="not-italic flex flex-col gap-1">
                        <span className="text-lg md:text-xl font-bold tracking-tight text-secondary">
                          {quote.author}
                        </span>
                        <span className="text-sm text-muted-foreground uppercase tracking-widest font-mono font-semibold">
                          {quote.role}
                        </span>
                      </cite>
                    </div>
                  </div>
                </CarouselItem>) : <CarouselItem>
                <div className="flex items-center justify-center min-h-[400px] md:min-h-[500px] text-muted-foreground text-lg italic">
                  Client testimonials and safety success stories will appear here soon.
                </div>
              </CarouselItem>}
          </CarouselContent>

          {}
          <div className="absolute bottom-0 right-0 flex gap-4 z-10">
            <CarouselPrevious className="static translate-none size-14 rounded-none border border-border bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-200" variant="outline" />
            <CarouselNext className="static translate-none size-14 rounded-none border border-border bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-200" variant="outline" />
          </div>
        </Carousel>
      </div>
    </section>;
}